/** 密码8-20位，且包含大小写字母、数字、特殊字符中的3种及以上 */
export function validateAdminPassword(password: string): boolean {
  if (!password || password.length < 8 || password.length > 20) return false;
  let types = 0;
  if (/[A-Z]/.test(password)) types++;
  if (/[a-z]/.test(password)) types++;
  if (/[0-9]/.test(password)) types++;
  if (/[^a-zA-Z0-9]/.test(password)) types++;
  return types >= 3;
}

export const ADMIN_PASSWORD_RULES = [
  { required: true, message: '请输入密码' },
  { min: 8, max: 20, message: '密码长度应为8-20位' },
  {
    validator: (val: string) => validateAdminPassword(val),
    message: '密码需包含大小写字母、数字、特殊字符中的3种及以上',
  },
];
